import React from "react";

import "../../pages/administration/AdministrationPage.css";
import VerticalTabs from "../tabs/VerticalTabs";
import FunctionalTableComponent from "../table/FunctionalTableComponent";
import SimpleDictionaryFormConfig from "../common/SimpleDictionaryFormConfig";
import columns from "../common/SimpleDictionaryTableConfig";
import { useTranslation } from 'react-i18next';


const DictionariesManagementComponent = ({setLoader, dictionaries}) => {

    const { t } = useTranslation();


    const tabsConfig = {
        defaultActiveKey: dictionaries[0].api,
        tabs: dictionaries.map(d => {
            return {
                key: d.api,
                label: d.label,
                content: <FunctionalTableComponent
                    title={d.tableLabel || d.label}
                    creationTitle={d.creationLabel}
                    creationFields={d.fields || SimpleDictionaryFormConfig(t)}
                    remove={true}
                    columns={d.columns || columns}
                    header={true}
                    api={d.api}
                    setLoader={setLoader}
                    readOnly={d.readOnly}
                    width={12}
                    editWithId={d.editWithId}
                    editable={d.editable}
                    pagination={true}
                    deleteModalTitle={d.deleteModalTitle}
                    deleteModalDescription={d.deleteModalDescription}
                    modalSize={d.modalSize}
                />
            }
        })
    }
    return (
        <>

            <VerticalTabs
                config={tabsConfig}

            />


        </>
    );
};


export default DictionariesManagementComponent;
